export const app_active_psasive_en = {
  true: 'Active',
  false: 'Passive',
};
